export function resultDateTransformer(p: Promise<any>, dateKey: string = 'date') {
    return p.then((res) => {
        return res.map(res => {
            return {
                ...res,
                [dateKey]: new Date(res[dateKey])
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/utils/date.ts